import {
  mapPaymentToMembershipTransaction,
  MembershipTransactionPayload,
} from '@models/membership/MembershipTransaction'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_TRANSACTIONS_URL } from '@utils/urls'

// The endpoint serves the shared payment resource, so the rows are flattened
// here: everything downstream (store, table, SBRM view) keeps reading the flat
// `MembershipTransaction`.
const fetchMembershipTransactions = (params: TableParams) =>
  SBAPI.FetchPaginated<MembershipTransactionPayload[]>(
    MEMBERSHIP_TRANSACTIONS_URL,
    params
  ).then((response) => ({
    ...response,
    // `?? []`: an empty payload must land on the table's empty state, not throw
    // its way into the slice's error state.
    data: (response.data ?? []).map(mapPaymentToMembershipTransaction),
  }))

export { fetchMembershipTransactions }
